import { COMPANY_GROUPS } from "../constants/fonterraConfig";
import { POLITICAL_GROUPS } from "../constants/politicalConfig";

export function getPolColours() {
  return [
    "#4e79a7", "#f28e2b", "#e15759", "#76b7b2", "#59a14f",
    "#edc948", "#b07aa1", "#ff9da7", "#9c755f", "#bab0ab",
  ];
}

export function getPolConfig() {
  const withCategory = (groups, category) =>
    Object.fromEntries(Object.entries(groups).map(([id, g]) => [id, { ...g, category }]));

  const allGroups = {
    ...withCategory(COMPANY_GROUPS, "company"),
    ...withCategory(POLITICAL_GROUPS, "political"),
  };
  const groupsById = Object.fromEntries(
    Object.entries(allGroups).map(([id, g]) => [id, { ...g, schema: "nz_single" }])
  );
  return { groupsById };
}
